import { useEffect } from 'react';
import { handleBrowserCompatibilityDirect } from '../utils/browserDetection';
import InstagramBrowserModal from './InstagramBrowserModal';

const BrowserDetection = () => {
  useEffect(() => {
    // Check browser compatibility only once per session
    if (!sessionStorage.getItem('browserRedirectAttempted')) {
      handleBrowserCompatibilityDirect();
      sessionStorage.setItem('browserRedirectAttempted', 'true');
    }
  }, []);

  return (
    <>
      <InstagramBrowserModal />
    </>
  );
};

export default BrowserDetection;
